// library imports
import { Button, Form, InputNumber, Flex, Skeleton, DatePicker } from "antd";
import { useEffect, useState, useContext } from "react";
import dayjs from "dayjs";
// hook imports
import useFetch from "../../../hooks/useFetch";
// context imports
import { IndexContext } from "../../../context/IndexContext";
// config imports
import { FORM_REQUIRED } from "../../../configs/configs";

export default function PieceProductForm({
  mode,
  setIsModalOpen,
  refreshTable,
  refreshYearList,
  initialValues,
  siteSelected,
  disabledYears,
}) {
  // fetch wrapper
  const [fetchWrapper] = useFetch();

  // loading states
  const [loading, setLoading] = useState(false); // loading state for form
  const [loadingSubmitButton, setLoadingSubmitButton] = useState(false); // loading state for submit button

  const [pieceProductForm] = Form.useForm();

  // load index context
  const { messageApi } = useContext(IndexContext);

  /* API to add piece product */
  function addPieceProduct(user_inputs) {
    setLoadingSubmitButton(true);
    fetchWrapper({
      endpoint_url: "piece_product_management/addPieceProduct",
      body: {
        site_id: siteSelected,
        year_selected: user_inputs.Year.format("YYYY"),
        piece_product: user_inputs.PieceProduct,
      },
      onSuccess: (fetch_output) => {
        messageApi.open({
          type: "success",
          content: fetch_output.message,
        });
        setIsModalOpen(false);
        pieceProductForm.resetFields();
        setLoadingSubmitButton(false);
        refreshTable();
        refreshYearList();
      },
    });
  }

  /* API to edit piece product */
  function editPieceProduct(user_inputs) {
    setLoadingSubmitButton(true);
    fetchWrapper({
      endpoint_url: "piece_product_management/editPieceProduct",
      body: {
        piece_product_id: initialValues[0].ID,
        piece_product: user_inputs.PieceProduct,
      },
      onSuccess: (fetch_output) => {
        if (fetch_output.data === true) {
          messageApi.open({
            type: "success",
            content: fetch_output.message,
          });
          setIsModalOpen(false);
        } else {
          messageApi.open({
            type: "error",
            content: fetch_output.message,
          });
        }
        pieceProductForm.resetFields();
        setLoadingSubmitButton(false);
        refreshTable();
      },
    });
  }

  useEffect(() => {
    if (mode === "edit") {
      setLoading(true);
      if (initialValues.length) {
        initialValues[0].Year = dayjs(String(initialValues[0].Year), "YYYY");
        pieceProductForm.setFieldsValue(initialValues[0]);
        setLoading(false);
      }
    }
  }, [mode, initialValues]);

  return (
    <>
      {loading ? (
        <Skeleton />
      ) : (
        <Form
          form={pieceProductForm}
          name="piece-product-form"
          labelCol={{
            span: 12,
          }}
          wrapperCol={{
            span: 12,
          }}
          onFinish={(values) => {
            if (mode === "add") {
              addPieceProduct(values);
            } else {
              editPieceProduct(values);
            }
          }}
          autoComplete="off"
        >
          <Form.Item
            label="Year"
            name="Year"
            rules={[
              {
                required: FORM_REQUIRED,
                message: "Year cannot be empty.",
              },
            ]}
          >
            <DatePicker
              picker="year"
              style={{ width: "100%" }}
              disabled={mode === "edit"}
              // disable year which the piece product is in database
              disabledDate={(current) => {
                if (!current) return false;
                const year = current.year();
                return disabledYears.includes(year);
              }}
            />
          </Form.Item>

          <Form.Item
            label="Product Produced (Pieces)"
            name="PieceProduct"
            rules={[
              {
                required: FORM_REQUIRED,
                message: "PieceProduct cannot be empty.",
              },
            ]}
          >
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>

          <Flex justify="center">
            <Button
              className="mr-2"
              onClick={() => {
                setIsModalOpen(false);
                pieceProductForm.resetFields();
              }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              loading={loadingSubmitButton}
            >
              Submit
            </Button>
          </Flex>
        </Form>
      )}
    </>
  );
}
